import { reconciliationConstants } from "../constants";
import { createParams } from "./base.reducers";

const name = "reconciliations";

const initialState = {
  allLoading: 0,

  reconciliations: [],
  reconciliationsById: {}
};

export default (state = initialState, payload) => {
  const { type, data } = payload;
  switch (type) {
    // Load reconciliations
    case reconciliationConstants.LOAD_RECONCILIATIONS_REQUEST:
      return {
        ...state,
        allLoading: state.allLoading + 1
      };
    case reconciliationConstants.LOAD_RECONCILIATIONS_SUCCESS:
      return {
        ...createParams({
          name,
          state,
          data: data.data
        }),
        allLoading: state.allLoading - 1
      };
    case reconciliationConstants.LOAD_RECONCILIATIONS_FAILURE:
      return {
        ...state,
        allLoading: state.allLoading - 1
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/reconciliation.reducers.js